// extracted by mini-css-extract-plugin
module.exports = {"button":"_2frTMC2G","toolTip":"_18TTWNC8"};